// LCP fix (2026-05-17, hardened after Codex review):
// lazy-autoplay videos via IntersectionObserver
// - idempotent activate()
// - explicit iOS Safari autoplay prereqs (muted, playsInline)
// - skip inactive (display:none) videos at activation time
// - handle play() rejection silently (Low Power Mode etc.)
(function () {
  function activate(video) {
    if (!video || video.dataset.lazyActivated === '1') return;
    // skip videos in inactive containers (e.g. interactive-banner inactive slide)
    if (video.offsetParent === null && !video.classList.contains('always-activate')) return;

    video.dataset.lazyActivated = '1';

    var sources = video.querySelectorAll('source[data-lazy-src]');
    sources.forEach(function (s) {
      s.setAttribute('src', s.getAttribute('data-lazy-src'));
      s.removeAttribute('data-lazy-src');
    });
    var rootLazy = video.getAttribute('data-lazy-src');
    if (rootLazy) {
      video.setAttribute('src', rootLazy);
      video.removeAttribute('data-lazy-src');
    }
    video.removeAttribute('data-lazy-video');

    // iOS Safari autoplay prereqs — must be set BEFORE play()
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    try { video.load(); } catch (e) {}
    video.setAttribute('autoplay', '');

    var p;
    try { p = video.play(); } catch (e) {}
    if (p && typeof p.catch === 'function') {
      p.catch(function () { /* low-power-mode etc — poster stays visible */ });
    }
  }

  function activateAll() {
    document.querySelectorAll('video[data-lazy-video]').forEach(activate);
  }

  function init() {
    if (!('IntersectionObserver' in window)) {
      activateAll();
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activate(entry.target);
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '250px 0px', threshold: 0.01 });

    document.querySelectorAll('video[data-lazy-video]').forEach(function (v) {
      obs.observe(v);
    });

    // Re-scan if interactive-banner switches active block (slide change adds new videos to DOM scope)
    var bannerScope = document.querySelector('[data-section-type*="interactive-banner"], .section-interactive-banner');
    if (bannerScope && 'MutationObserver' in window) {
      new MutationObserver(function () {
        document.querySelectorAll('video[data-lazy-video]').forEach(function (v) {
          if (v.dataset.lazyActivated !== '1') obs.observe(v);
        });
      }).observe(bannerScope, { attributes: true, subtree: true, attributeFilter: ['class', 'data-selected', 'aria-hidden'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
